import { Navigate } from 'react-router-dom';
import { Loading } from '@/components/Loading';
import { ErrorState } from '@/components/ErrorState';
import { pickDefaultYear, useFiscalYears } from '@/fiscal-year/FiscalYearProvider';

/** `/` → 前回選択した年度（なければ当年度）のポータルへ */
export function RootRedirect() {
  const { data, isPending, error, refetch } = useFiscalYears();
  if (isPending) return <Loading fullscreen label="事業年度を読み込んでいます" />;
  if (error) return <ErrorState error={error} onRetry={() => void refetch()} />;
  const year = pickDefaultYear(data);
  if (year == null) return <ErrorState error={null} title="事業年度が登録されていません" description="管理者に事業年度の登録を依頼してください。" />;
  return <Navigate to={`/years/${year}`} replace />;
}
